function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { IsOfferFeatureEnabled, MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { retrieveSubscriberOfferingDetail } from '../../../../../reducers/actions/customer.actions';
import { AccountOfferingsSelector } from '../../../../../reducers/selectors/dashboard.selectors';
import { CurrentCustomerSelector, CurrentCustomerIdSelector, SelectedTabServicesAndOffersSelector } from '../../../../../reducers/selectors/customer.selectors';
import { ConvergentBillerAccountDetailsSelector, IsFetchingAccountDetailsSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { SelectedOfferingAndOptionsSelector, SelectedSubscriberOfferingInstanceIdSelector } from '../../../../../reducers/selectors/search.subscriber.offerings.selectors';
import localeKeys from '../../../../../locales/keys';
import { SERVICES_AND_OFFERS_TABS } from '../servicesAndOffers/services.and.offers.contants';
var OfferingListController = /*#__PURE__*/function () {
  function OfferingListController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, OfferingListController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      localeKeys: localeKeys,
      SERVICES_AND_OFFERS_TABS: SERVICES_AND_OFFERS_TABS,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OfferingListController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          accountDetails: ConvergentBillerAccountDetailsSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          featureConfigurationsLoaded: MetadataCodeLoadedSelector(CODES.FeatureConfiguration, store),
          isFetchingAccountDetails: IsFetchingAccountDetailsSelector(store),
          isItvOffersEnabled: IsOfferFeatureEnabled(store),
          newOfferWidgetSelectedTab: SelectedTabServicesAndOffersSelector(store),
          offerings: AccountOfferingsSelector(store),
          selectedOffering: SelectedOfferingAndOptionsSelector(store),
          selectedOfferingInstanceId: SelectedSubscriberOfferingInstanceIdSelector(store),
          subscriptionBillingCyclesLoaded: MetadataCodeLoadedSelector(CODES.SubscriptionBillingCycle, store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveSubscriberOfferingDetail: retrieveSubscriberOfferingDetail
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.isItvOffersEnabled || !this.state.featureConfigurationsLoaded) {
        if (!this.state.subscriptionBillingCyclesLoaded) {
          this.actions.fetchCodeTypes(CODES.SubscriptionBillingCycle);
        }
      }
    }
  }, {
    key: "fetchOfferingDetails",
    value: function fetchOfferingDetails() {
      var _this2 = this;
      if (this.state.selectedOfferingInstanceId) {
        this.actions.retrieveSubscriberOfferingDetail(this.state.currentCustomerId, this.state.selectedOfferingInstanceId).then(function () {
          return _this2.actions.retrieveOfferingsMetadata([_this2.state.selectedOffering.OfferingId]);
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "onRefreshServices",
    value: function onRefreshServices() {
      this.refreshServices && this.refreshServices();
    }
  }]);
}();
export default {
  template: require('./offering.list.deprecated.html'),
  bindings: {
    hasAdminAccess: '<',
    refreshServices: '&?',
    refreshConvergentBillerDetails: '&?'
  },
  controller: OfferingListController,
  controllerAs: 'OfferingList'
};